var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(180)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(210)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(240)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".1;0;1;.85;.7;.65;.55;.45;.35;.25;.15;.1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(270)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".15;.1;0;1;.85;.7;.65;.55;.45;.35;.25;.15",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(300)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".25;.15;.1;0;1;.85;.7;.65;.55;.45;.35;.25",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(330)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".35;.25;.15;.1;0;1;.85;.7;.65;.55;.45;.35",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".45;.35;.25;.15;.1;0;1;.85;.7;.65;.55;.45",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(30)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".55;.45;.35;.25;.15;.1;0;1;.85;.7;.65;.55",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(60)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".65;.55;.45;.35;.25;.15;.1;0;1;.85;.7;.65",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(90)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".7;.65;.55;.45;.35;.25;.15;.1;0;1;.85;.7",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(120)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: ".85;.7;.65;.55;.45;.35;.25;.15;.1;0;1;.85",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("line", {
    y1: 12,
    y2: 20,
    transform: "translate(32,32) rotate(150)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    dur: "750ms",
    values: "1;.85;.7;.65;.55;.45;.35;.25;.15;.1;0;1",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.95dcbcda17429a724238e375fa3ffb4b.svg";
export { ForwardRef as ReactComponent };